// aerospike config
export const aerospikePort = 3000;

export const aerospikeIp =
  process.env.BUILD_ENV === 'prod'
    ? [
        'm_flt_aspk-rms_1.mmt.mmt',
        'm_flt_aspk-rms_2.mmt.mmt',
        'm_flt_aspk-rms_3.mmt.mmt',
        'm_flt_aspk-rms_4.mmt.mmt',
        'm_flt_aspk-rms_5.mmt.mmt'
      ]
    : ['127.0.0.1'];

export const aerospikeNamespaceForFlights = process.env.BUILD_ENV === 'prod' ? 'ns_128' : 'test';

// FOR TESTING IN PRODPP USE THESE:

// export const aerospikeIp =
//   process.env.BUILD_ENV !== 'undefined'
//     ? [
//         'm_flt_aspk-rms_1.mmt.mmt',
//         'm_flt_aspk-rms_2.mmt.mmt',
//         'm_flt_aspk-rms_3.mmt.mmt',
//         'm_flt_aspk-rms_4.mmt.mmt',
//         'm_flt_aspk-rms_5.mmt.mmt'
//       ]
//     : ['127.0.0.1'];

// export const aerospikeNamespaceForFlights =
//   typeof process.env.BUILD_ENV !== 'undefined' ? 'ns_128' : 'test';

// OLD
// export const aerospikeIp = process.env.BUILD_ENV === 'prod' ? ['flights-aerospike-01.prod.goibibo.com'] : ['127.0.0.1'];
// export const aerospikeNamespaceForFlights = process.env.BUILD_ENV === 'prod' ? 'flights' : 'test';
